// extracted by mini-css-extract-plugin
module.exports = {"arrow":"src-reactapp-shared-Popover---arrow","popover":"src-reactapp-shared-Popover---popover"};